import { callPolicyStore, type CallPolicyDraft } from 'state/store';

export const selectCallPolicyDraft = (): CallPolicyDraft => ({
    joinPolicy: callPolicyStore.joinPolicy,
    moderatorsApprovalOnly: callPolicyStore.moderatorsApprovalOnly,
});
